import {
  DEFAULT_FILTER_VALUES,
  SelectedFilters,
  useContactTaskListStore,
  useTaskCenterStore,
} from '@frontend/task-center-scope';

interface FilterState {
  selectedFilters: SelectedFilters;
  setFilters: (filters: SelectedFilters) => void;
}

/**
 * Hook that conditionally uses either useTaskCenterStore or useContactTaskListStore
 * based on availability. Prefers ContactTaskListStore when available (contact panel context),
 * falls back to TaskCenterStore (task center panel context).
 */
export const useGlobalFilterState = (fromContactPanel: boolean): FilterState => {
  // Try to get contact task list store first (contact panel context)
  const contactPanelFilterInfo = useContactTaskListStore((s) => ({
    selectedFilters: s?.selectedFilters,
    setFilters: s?.setFilters,
  }));

  // Get task center store as fallback (task center panel context)
  const taskCenterFilterInfo = useTaskCenterStore(['selectedFilters', 'setFilters']);

  if (fromContactPanel) {
    return {
      selectedFilters: contactPanelFilterInfo?.selectedFilters || DEFAULT_FILTER_VALUES,
      setFilters: contactPanelFilterInfo?.setFilters || (() => {}),
    };
  }

  return {
    selectedFilters: taskCenterFilterInfo.selectedFilters,
    setFilters: taskCenterFilterInfo.setFilters,
  };
};
